module.exports = __webpack_public_path__ + "img/calfcircumference.f4f6432f.jpeg";